import { createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { ChartViewComponent } from '@teamimprover/ti-orgchart';
import { importProvidersFrom, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { DndModule, provideDnd } from '@ng-dnd/core';
import { HTML5ToTouch, MultiBackend } from '@ng-dnd/multi-backend';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { provideAnimations } from '@angular/platform-browser/animations';

// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));

createApplication({
    providers: [
        provideAnimations(),
        provideExperimentalZonelessChangeDetection(),
        provideDnd({ backend: MultiBackend, options: HTML5ToTouch }),
    ],
}).then((app) => {
    const chartElement = createCustomElement(ChartViewComponent, {
        injector: app.injector,
    });
    customElements.define('ti-orgchart-element', chartElement);
});
